import Vue from 'vue'
import Router from 'vue-router'
import AuthGuard from './auth-guard'

import About from '@/components/User/About'
import Profile from '@/components/User/Profile'
import ProfileGuests from '@/components/User/ProfileGuests'
import Signin from '@/components/User/Signin'
import Signup from '@/components/User/Signup'
import SignupConfirm from '@/components/User/SignupConfirm'
import ForgetPassword from '@/components/User/ForgetPassword'
import Search from '@/components/Guests/Search'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'SignIn',
      component: Signin
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      beforeEnter: AuthGuard
    },
    {
      path: '/profile-guests',
      name: 'ProfileGuests',
      component: ProfileGuests,
      beforeEnter: AuthGuard
    },
    {
      path: '/signin',
      name: 'Signin',
      component: Signin
    },
    {
      path: '/signup',
      name: 'Signup',
      component: Signup
    },
    {
      path: '/signup-confirm',
      name: 'SignupConfirm',
      component: SignupConfirm
    },
    {
      path: '/forget-password',
      name: 'ForgetPassword',
      component: ForgetPassword
    },
    {
      path: '/search',
      name: 'Search',
      component: Search,
      beforeEnter: AuthGuard
    },
    {
      path: '*',
      name: 'SignIn',
      component: Signin
    }
  ],
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js